<template>
  <div class="tag-dialog-selector">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :loading="dialogLoading"
      custom-class="tag-dialog"
      width="666px">
      <div v-if="groupList.length&&dialogVisible">
        <p class="tips">请勾选顾客标签，可多选</p>
        <el-scrollbar style="height: 400px">
          <div class="group-list">
            <div class="group-box" v-for="group in groupList" :key="group.id">
              <p class="group-title">{{group.groupName}}</p>
              <div class="tag-list">
                <!-- <el-checkbox v-for="tag in group.children" :key="tag.id" v-model="check[tag.id]" @change="(checked)=>onChange(checked,tag)">{{tag.tagName}}</el-checkbox> -->
                <span v-for="tag in group.children" :key="tag.id" :class="['tag-checkbox',{'del': tag.status}]">
                  <el-checkbox v-model="check[tag.id]" @change="(checked)=>onChange(checked,tag)">{{tag.tagName}}</el-checkbox>
                  <span v-show="tagCountMap[tag.id]">{{tagCountMap[tag.id]}}人</span>
                </span>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div v-else>
        <div class="empty">
          <p class="noTags">暂无顾客标签</p>
          <div v-if="havePower">
            <p class="toCreatedTip">您可以创建一些常用的标签</p>
            <el-button type="primary" @click="toCreated">立即创建</el-button>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" v-if="groupList.length">
        <span><span v-show="havePower">没有想要的标签？<span class="toCreated" @click="toCreated">点我去添加></span></span></span>
        <div class="dialog_buttons">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="onComfrim">{{confirmText || `确定添加 ${selectedTags.length}个 标签`}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'tagDialogSelector',
  props: {

  },
  components: {},
  data() {
    return {
      groupObj: {},
      selectedTags: [],
      dialogLoading: true,
      dialogVisible: false,
      groupList: [],
      check: {},
      defaultCheckedKeys: [],
      title: "增加标签",
      tagCountMap: {},
      havePower: false,
      toCreatedFunc: null,
      manualClose: true,
      userInfo: null,
      shopMaps: null
    }
  },
  watch: {
  },
  computed: {
    isChanged() {
      return this.selectedTags.length !== this.defaultCheckedKeys.length || this.selectedTags.some(tagData => {
        return !this.defaultCheckedKeys.includes(tagData.id);
      })
    },
    confirmText() {
      return this.isChanged ? null : '确定';
    },
  },
  methods: {
    toCreated() {
      if (this.toCreatedFunc) {
        this.toCreatedFunc()
      } else {
        if (window.parent.parent.location.pathname.indexOf('components/shair-web') !== -1) {
          window.open('/shair/components/shair-web/index.html#/main/iframe?url=/shair/components/baseSetting/index.html#/tagSetting','_blank')
        } else {
          window.open('/shair/tag!init.action','_blank')
        }
        
      }
    },
    show(params) {
      this.reset()
      let { title, loadData, defaultCheckedKeys, shopList, onComfrim, loadCount, toCreated, userInfo, customerTag, manualClose, shopMaps } = params
      this.title = title || "增加标签"
      this.defaultCheckedKeys = defaultCheckedKeys || []
      this.shopList = shopList || []
      this.manualClose = manualClose
      this.userInfo = userInfo
      this.havePower = this.userInfo.operateStr && this.userInfo.operateStr.indexOf('a83') !== -1 && this.userInfo.shopId === this.userInfo.parentShopId
      this.shopMaps = shopMaps
      this.onComfrimFunc = onComfrim
      this.toCreatedFunc = toCreated
      if (defaultCheckedKeys && defaultCheckedKeys.length) {
        defaultCheckedKeys.forEach(t => {
          this.$set(this.check, t, true)
        })
      }
      if (loadData) {
          this.dialogLoading = true;
          loadData(this.loadDataCallback);
      }
      if (loadCount) {
         loadCount(this.loadCountCallback)
      }
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    reset() {
      for (let k in this.check) {
        this.$set(this.check, k, false)
      }
      this.selectedTags = []
    },
    onChange(checked, item) {
      if (checked) {
        if (this.selectedTags.length >= 20) {
          this.$message.error("最多只能添加20个标签！")
          this.check[item.id] = false
          return
        }
        this.selectedTags.push(item)
      } else {
        var index = this.selectedTags.findIndex(t => t.id === item.id); 
        if (index > -1) { 
          this.selectedTags.splice(index, 1);
        }
      }
    },
    onComfrim() {
      this.onComfrimFunc(this.selectedTags)
      if (!this.manualClose) {
        this.dialogVisible = false
      }
    },
    loadCountCallback(tagCountList) {
      tagCountList.forEach(t => {
        this.tagCountMap[t.id] = t.count
      })
    },
    loadDataCallback(listData) {
      this.groupList = this.processData(listData)
      this.dialogLoading = false
      this.defaultCheckedKeys.forEach(t => {
        this.selectedTags.push(listData.find(item => item.id === t))
      })
    },
    processData(tagList) {
      let groupObj = {}
      let groupSort = {}
      let realGroupSort = {}
      let groupList = []
      tagList.forEach(item => {
        if (!item.groupId) {
          item.groupName = '其他'
          item.groupId = -1
          item.groupSortNum = -1
        }
        if (!groupObj[item.groupId]) {
          groupObj[item.groupId] = [item]
        } else {
          groupObj[item.groupId].push(item)
        }
        if (!groupSort[item.groupShopId]) {
          groupSort[item.groupShopId] = [{
            groupName: item.groupName,
            groupId: item.groupId,
            groupSortNum: item.groupSortNum
          }]
        } else {
          groupSort[item.groupShopId].push({
            groupName: item.groupName,
            groupId: item.groupId,
            groupSortNum: item.groupSortNum
          })
        }
      })
      for (let k in groupObj) {
        groupObj[k] = groupObj[k].sort((a, b) => {
          let aShop = this.shopMaps[Number(a.shopId)] || {softgenre: 2}
          let bShop = this.shopMaps[Number(b.shopId)] || {softgenre: 2}
          return aShop.softgenre - bShop.softgenre
        })
      }
      for (let i = 0; i < this.shopList.length; i++) {
        const k = this.shopList[i];
        if (groupSort[k]) {
          let sort = groupSort[k].sort((a, b) => a.groupSortNum - b.groupSortNum).map( t => t.groupId || '其他')
          realGroupSort[k] = Array.from(new Set(sort))
        }
      }
      for (let k in realGroupSort) {
        for (let i = 0; i < realGroupSort[k].length; i++) {
          const groupId = realGroupSort[k][i];
          if (groupId !== -1) {
            groupList.push({
              children: groupObj[groupId] || [],
              groupName: groupObj[groupId][0].groupName,
              groupId: groupObj[groupId][0].groupId,
              groupSortNum: groupObj[groupId][0].groupSortNum,
              shopId: groupObj[groupId][0].shopId,
              parentShopId: groupObj[groupId][0].parentShopId,
              className: groupObj[groupId][0].groupShopId !== groupObj[groupId][0].parentShopId ? 'shop' : ''
            })
          }
        }
      }
      for (let k in groupObj) {
        let item = groupObj[k]
        let children = item.filter(t => t.id)
        if (!groupList.some(t => t.groupId === item[0].groupId) && k !== "-1" && children && children.length) {
          groupList.push({
            children: children || [],
            groupName: item[0].groupName,
            groupId: item[0].groupId,
            groupSortNum: item[0].groupSortNum,
            shopId: item[0].shopId,
            parentShopId: item[0].parentShopId,
            className: item[0].groupShopId !== this.parentShopId ? 'shop' : ''
          })
        }
      }
      if (groupObj[-1]) {
        groupList.push({
          children: groupObj[-1],
          groupName: '其他',
          groupId: -1,
          groupSortNum: -1,
          shopId: groupObj[-1][0].shopId,
          parentShopId: groupObj[-1][0].parentShopId,
          className: 'order'
        })
      }
      console.log(groupList);
      return groupList
    },
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss">
.tag-dialog-selector{
  .empty{
    height: 340px;
    text-align: center;
    padding-top: 210px;
    background: url("./tagsEmpty.png") no-repeat 50% 0;
    .noTags{
      font-size: 13px;
      color: #999999;
      margin-bottom: 4px;
    }
    .toCreatedTip{
      font-size: 12px;
      color: #AAAAAA;
      margin-bottom: 11px;
    }
  }
  .el-dialog__footer {
    padding: 0 28px 26px 20px;
    .toCreated{
      color: #409EFF;
      cursor: pointer;
      margin-left: 5px;
    }
    .el-button {
      font-size: 12px;
      border-radius: 2px;
    }
    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .dialog_buttons {
      display: flex;
      justify-content: flex-end;
    }
    .el-button--primary {
      width: auto;
    }
    .dialog_tips {
      font-size: 12px;
      line-height: 1.3;
      color: #999;
    }
  }
  .el-dialog__title{
    font-weight: Bold;
    font-size: 13px;
    color: #333333;
  }
  .tips{
    font-size: 14px;
    color: #909090;
    padding: 0px;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .el-dialog__body{
    padding: 0px 20px;
  }
  .group-list{
    height: 400px;
  }
  .el-checkbox__label{
    display: inline-block;
    width: 114px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    vertical-align: bottom;
  }
  .group-box{
    border-radius: 6px;
    padding: 0px;
    .el-checkbox{
      // margin-right: 20px !important;
    }
    .group-title{
      font-weight: 600;
      font-size: 14px;
      color: #222;
      margin: 10px 0;
      .iconfont{
        font-size: 12px;
        color: #6D6D6D;
        margin-left: 6px;
        cursor: pointer;
        &:hover{
          color: #409EFF;
        }
      }
      &.shop{
        color: #E8684A;
      }
      &.order{
        color: #222222;
      }
    }
    .tag-list{
      .addTagInput{
        width: 137px;
        height: 30px;
        background: #FFFFFF;
        border-radius: 6px;
        margin-right: 6px;
        input{
          height: 30px;
          line-height: 30px;
        }
      }
      .addTag{
        vertical-align: top;
        text-align: center;
        display: inline-block;
        width: 102.5px;
        height: 30px;
        line-height: 30px;
        background: #FFFFFF;
        border: 0.5px solid #DFE1E8;
        border-radius: 2px;
        font-size: 12px;
        color: #409EFF;
        cursor: pointer;
        .iconfont{
          margin-right: 5px;
          font-size: 12px;
        }
      }
    }
    .tag-checkbox{
      display: inline-block;
      line-height: 14px;
      padding: 4px 8px;
      background: #FFFFFF;
      border: 0.5px solid #DFE1E8;
      border-radius: 6px;
      margin-right: 10px;
      margin-bottom: 10px;
      position: relative;
      &.del{
        border-style: dashed;
      }
      .el-checkbox{
        margin-right: 0;
        // padding-right: 30px;
        .el-checkbox__label{
          color: #333;
        }
      }
      &>span{
        font-size: 12px;
        color: #ABABAB;
        min-width: 27px;
        display: inline-block;
        position: absolute;
        right:5px;
        top: 7px;
      }
    }
  }
}
</style>

